/**
 * @file index.tsx
 *
 * @fileoverview Renders the setup for Google Leaderboard Banner Ad script.
 */
import Script from 'next/script';
import AlignedCenter from '~/vcl/atoms/06-layout/01-alignment/01-align-center';
import React from 'react';

interface AdnuntiusMpu1BannerAdProps {}
export default function AdnuntiusMpu1BannerAd({}: AdnuntiusMpu1BannerAdProps) {
  return (
    <AlignedCenter>
      <div
        id="adn-5bf3c"
        style={{
          display: 'none',
        }}
      ></div>
      <Script
        dangerouslySetInnerHTML={{
          __html: `
            window.adn = window.adn || {}; adn.calls = adn.calls || []; adn.calls.push(function() { adn.request({ network: '57ff2', adUnits: [ {auId: '5bf3c', auW: 300, auH: 250 } ]}); });
          `,
        }}
      />
    </AlignedCenter>
  );
}
